import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { CONTENT_MANAGEMENT } from 'commons/constants/permissions'

const ReportDownload = lazy(() => import('pages/ReportDownload'))

export default [
  {
    path: '/reportDownload',
    component: ReportDownload,
    permissions: CONTENT_MANAGEMENT,
  },
] as Route[]
